(function () {
    'use strict';

    a3_cabin_reports.controller('PassengerMealsCtrl', PassengerMealsCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name PassengerMealsCtrl
    * @description 
    *  Manages the Meal Library View
    * @ngInject
    */

    function PassengerMealsCtrl($scope, PassengerMealServiceFactory) {
        $scope.state = 'mealLibrary'; 
        $scope.selectedService = null;  
        $scope.selectedCycle = null;  
        $scope.filteredMeals = [];  
        $scope.isAllCyclesSelected = false;
        $scope.areAllMealsOpen = false;
        $scope.filteredServices = [];
        $scope.mealServiceSearch = '';

        $scope.selectService = selectService;
        $scope.filterByCycle = filterByCycle;
        $scope.toggleAllMeals = toggleAllMeals;
        $scope.searchMeals = searchMeals;
        $scope.toggleSidePanel = toggleSidePanel;
        $scope.filterMealServices = filterMealServices;

        PassengerMealServiceFactory.getPassengerMealServicesFromStorage(function (results) {
            $scope.passengerMeals = results;

            if ($scope.passengerMeals.length > 0) {            
                $scope.selectService($scope.passengerMeals[0]);    
                $scope.filteredServices = angular.copy($scope.passengerMeals);            
            }
        });
  
        // Select a service and reset cycles and meals
        function selectService (service) {
            $scope.selectedService = service;  // Set the selected service
            $scope.isAllCyclesSelected = false;

            // Clear the search field when selecting a new service
            $scope.searchText = '';

            // Check if the service has cycles and filter by the first cycle
            if (service.ServiceCycles && service.ServiceCycles.length > 0) {
                $scope.filterByCycle(service.ServiceCycles[0]);
            } else {
                $scope.selectedCycle = null;  
                $scope.filteredMeals = [];
            }
        };

        // Filter meals by cycle when cycle radio button is selected
        function filterByCycle(cycle) {
            $scope.selectedCycle = cycle;
            $scope.isAllCyclesSelected = false; 

            // Clear the search field
            $scope.searchText = '';

            $scope.filteredMeals = cycle.Meals.sort((a, b) => a.MealName.localeCompare(b.MealName));
        };     

        function filterMealServices() { 
           if ($scope.mealServiceSearch && $scope.mealServiceSearch.length >= 2){
            $scope.filteredServices  = $scope.passengerMeals.filter(service => 
                service.ServiceName.toLowerCase().includes($scope.mealServiceSearch.toLowerCase())
            );
           } else{
            $scope.filteredServices = angular.copy($scope.passengerMeals);
           }
        };     

        // Toggle opening/closing all meals
        function toggleAllMeals() {
            $scope.areAllMealsOpen = !$scope.areAllMealsOpen;
            $scope.filteredMeals.forEach(function (meal) {
                meal.isInfoVisible = $scope.areAllMealsOpen;
            });
        };

        // Search meals within the selected service or cycle
        function searchMeals() {
            if ($scope.searchText && $scope.searchText.length >= 2) {
                var searchTextLower = $scope.searchText.toLowerCase();

                // If a specific cycle is selected, filter meals by that cycle
                if ($scope.selectedCycle) {
                    $scope.filteredMeals = $scope.selectedCycle.Meals.map(meal => {
                        var mealNameMatch = meal.MealName.toLowerCase().includes(searchTextLower);

                        // Filter meal items that match search criteria
                        var filteredMealItems = meal.MealItems.map(item => {
                            var itemNameMatch = item.ItemName.toLowerCase().includes(searchTextLower);
                            var allergenMatch = item.Allergen ? item.Allergen.toLowerCase().includes(searchTextLower) : false;
                            var compositionMatch = item.Composition ? item.Composition.toLowerCase().includes(searchTextLower) : false;

                            var matchFound = itemNameMatch || allergenMatch || compositionMatch;
                            item.highlight = matchFound;  // Highlight matched items

                            return item;
                        }).filter(item => item.highlight);

                        // Return the meal if it or its items match the search
                        if (mealNameMatch || filteredMealItems.length > 0) {
                            return {
                                ...meal,
                                MealItems: filteredMealItems,
                                highlight: mealNameMatch
                            };
                        }
                        return null;
                    }).filter(meal => meal !== null);

                    // If "All Cycles" is selected, filter meals from all cycles in the selected service
                } else if ($scope.isAllCyclesSelected) {
                    $scope.filteredMeals = $scope.selectedService.ServiceCycles
                        .flatMap(cycle => cycle.Meals.map(meal => {
                            var mealNameMatch = meal.MealName.toLowerCase().includes(searchTextLower);

                            var filteredMealItems = meal.MealItems.map(item => {
                                var itemNameMatch = item.ItemName.toLowerCase().includes(searchTextLower);
                                var allergenMatch = item.Allergen ? item.Allergen.toLowerCase().includes(searchTextLower) : false;
                                var compositionMatch = item.Composition ? item.Composition.toLowerCase().includes(searchTextLower) : false;

                                var matchFound = itemNameMatch || allergenMatch || compositionMatch;
                                item.highlight = matchFound;

                                return item;
                            }).filter(item => item.highlight);

                            if (mealNameMatch || filteredMealItems.length > 0) {
                                return {
                                    ...meal,
                                    MealItems: filteredMealItems,
                                    highlight: mealNameMatch
                                };
                            }
                            return null;
                        }))
                        .filter(meal => meal !== null)
                        .sort((a, b) => a.MealName.localeCompare(b.MealName));  // Sort meals alphabetically
                } else {
                    // If no cycle is selected, reset the meals (optional behavior if needed)
                    $scope.filteredMeals = [];
                }

            } else {
                // If the search text is empty, show all meals for the selected cycle or all cycles
                if ($scope.selectedCycle) {
                    $scope.filteredMeals = $scope.selectedCycle.Meals;
                } else if ($scope.isAllCyclesSelected) {
                    $scope.filteredMeals = $scope.selectedService.ServiceCycles
                        .flatMap(cycle => cycle.Meals)
                        .sort((a, b) => a.MealName.localeCompare(b.MealName));  // Sort meals alphabetically
                } else {
                    $scope.filteredMeals = [];
                }
            }
        }

        // Toggle visibility of meal details
        $scope.toggleVisibility = function (meal) {
            meal.isInfoVisible = !meal.isInfoVisible;
        };
    
        function toggleSidePanel() {
            $scope.shownSideMenu = !$scope.shownSideMenu;
        }
    }
})();